import { useContext } from "react"
import LanguageContext from "./LanguageContext"

const useLanguageContext = () => useContext(LanguageContext)
export default useLanguageContext
